import React from "react";
import { useSelector } from "react-redux";
import { WrappedFieldProps } from "redux-form";

import { FormDropdown } from "features/forms/components/FormDropdownMenu";
import { getRegion } from "features/regions/selectors";

import { YEAR_GROUPS } from "./consts";

type Props = WrappedFieldProps & {
  isDisabled?: boolean;
};

export default function YearGroupDropdown(props: Props) {
  const { input, meta, isDisabled } = props;

  const region = useSelector(getRegion);

  return (
    <FormDropdown
      input={input}
      meta={meta}
      label="Year group"
      placeholder="Year group"
      options={YEAR_GROUPS[region!] ?? []}
      isDisabled={isDisabled}
      isSearchable={false}
      dataNoTranslate
    />
  );
}
